<template>
  <div class="login-wrap">
    <div class="login-form">
        <div class="sys-title">仓库出单管理</div>
        <a-form-model :model="formInline" @submit="handleSubmit" @submit.native.prevent>
            <a-form-model-item>
              <a-input v-model="formInline.user" placeholder="用户名">
                <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
              </a-input>
            </a-form-model-item>
            <a-form-model-item>
              <a-input v-model="formInline.password" type="password" placeholder="密码">
                <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
              </a-input>
            </a-form-model-item>
            <a-form-model-item>
              <a-button
                type="primary"
                html-type="submit"
                :disabled="formInline.user === '' || formInline.password === ''"
                style="width: 218px"
              >
                登录
              </a-button>
            </a-form-model-item>
          </a-form-model>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {SERVER_URL} from '@/http/config'
export default {
    data() {
    return {
      formInline: {
        user: '',
        password: '',
      },
    };
  },
  methods: {
    handleSubmit(e) {
      // const formData = new FormData();
      // formData.append('username', this.formInline.user)
      // formData.append('password', this.formInline.password)
      axios.post(`${SERVER_URL}/api-server/manage/user/login`, {username: this.formInline.user, password: this.formInline.password}).then(res => {
        if (res.data?.code === 200) {
          localStorage.setItem('token', res.data?.data?.token)
          this.$router.push({name: 'menuNav'})
        } else {
          this.$message.warning(res.data?.message || '登录失败')
        }
      })
    },
  },
}
</script>

<style>
.login-wrap{
    width: 100%;
    height: 100%;
    background: #214333;
    display: flex;
    justify-content: center;
    align-items: center;
}
.sys-title{
    color: #fff;
    font-size: 2rem;
    margin-bottom: 15px;
    text-align: center;
}
</style>